/* eslint-disable no-undef, strict, no-console, no-unused-vars, eqeqeq */
/* global STORE */

// TODO NOTE: After adding something here, check whether it also needs to be added to `custom.js` until jQuery is removed.

/*
* In this file there are variables used and defined in global\_footer.tpl.php
* var __currency = STORE.currency;
* var global_message = <?=json_encode($v->global_message)?>;
* var global_v3_error_message = <?=json_encode($v->global_v3_error_message)?>;
* var global_v3_notice_message = <?=json_encode($v->global_v3_notice_message)?>;
* var global_v3_warning_message = <?=json_encode($v->global_v3_warning_message)?>;
* var global_v3_success_message = <?=json_encode($v->global_v3_success_message)?>;
* */

const is_iOS = navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false;
const is_Android = navigator.userAgent.match(/(Android)/g) ? true : false;
const is_iOSwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*(Version|CriOS|FxiOS))/i.test(navigator.userAgent);

/* TODO this needs to be refactored/retested - concern: regex-based UA detection is unreliable */
const flag_regex = /(android|macintosh|windows|iphone).+safari/gi;
const flag_regex1 = /(windows|android).+chrome/gi;
const flag_fix = flag_regex.test(navigator.userAgent) && !flag_regex1.test(navigator.userAgent);

let bannerAnimationTimer;
let bannerAnimationCycle = 3000;

function dataLayerPush(obj) {
	console.log('dataLayerPush %o', obj);
	try {
		if (typeof dataLayer !== 'undefined') {
			dataLayer.push(obj);
			return true;
		}
	} catch (err) {
		// intentionally ignored
	}
	return false;
}

// Pushes a GTM tracking event to the dataLayer, then runs `proceed` once GTM
// confirms all tags for this event have fired (via eventCallback), or after
// `eventTimeout` ms if a tag is slow/blocked. If dataLayer itself is
// unavailable, it skips waiting entirely and runs `proceed` right away, so
// navigation/form submission is never blocked by tracking.
function trackThenProceed(category, action, label, proceed) {
	const buildTrackEvent = (callback, timeout = 1000) => ({
		event: 'trackEvent',
		eventCategory: category,
		eventAction: action,
		eventLabel: label,
		eventValue: 'value',
		eventProperty: 'property',
		eventCallback: callback,
		eventTimeout: timeout,
	});

	let done = false;
	const safeProceed = () => {
		if (done) return;
		done = true;
		proceed();
	};

	const pushed = dataLayerPush(buildTrackEvent(safeProceed));

	// If dataLayer isn't available at all (blocked, ad blocker, GTM not loaded),
	// don't wait on a callback that will never come — proceed immediately.
	if (!pushed) safeProceed();
}

function trackOutboundForm(form, category, action, label) {
	trackThenProceed(category, action, label, () => form.submit());
}

function trackOutboundLink(link, category, action, label) {
	trackThenProceed(category, action, label, () => {
		document.location.href = link.href;
	});
}

function trackExternalLink(link, category, action, label) {
	trackThenProceed(category, action, label, () => {
		const newTab = window.open(link.href, '_blank');
		if (newTab) newTab.focus();
	});
}

// TODO replace trackEvent with dataLayerPush
function trackEvent(category, action, label) {
	console.log('trackEvent %o %o %o', category, action, label);
	dataLayerPush({
		event: 'trackEvent',
		eventCategory: category,
		eventAction: action,
		eventLabel: label,
		eventValue: 'value',
		eventProperty: 'property',
	});
}

// TODO replace trackVirtualpage with dataLayerPush
function trackVirtualpage(pageUrl, pageTitle) {
	dataLayerPush({
		event: 'trackVirtualpage',
		virtualPageURL: pageUrl,
		virtualPagetitle: pageTitle,
	});
}

function scrollToAnchor(target, offsetTop) {
	const unwrapTargetElement = (targetToUnwrap) => {
		if (!targetToUnwrap) return null;

		if (typeof targetToUnwrap === 'string') {
			return document.querySelector(targetToUnwrap);
		}

		// Native DOM element/node
		if (targetToUnwrap instanceof Element) {
			return targetToUnwrap;
		}

		// jQuery object or similar array-like wrapper: $('#foo')[0]
		if (typeof targetToUnwrap.length === 'number' && targetToUnwrap[0] instanceof Element) {
			return targetToUnwrap[0];
		}

		return null;
	};

	try {
		history.scrollRestoration = 'manual';
	} catch (err) {
		console.warn(err);
	}

	try {
		const el = unwrapTargetElement(target);
		if (!el) return;

		const mainMenu = document.getElementById('main_menu');
		const defaultOffset = mainMenu ? mainMenu.offsetHeight : 0;
		const top = offsetTop ?? defaultOffset;
		const elTop = el.getBoundingClientRect().top + window.scrollY;

		window.scrollTo({
			top: elTop - top,
			behavior: 'smooth',
		});
	} catch (err) {
		console.warn(err);
	}
}

function createCookie(name, value, days, options = {}) {
	let expires = '';

	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = `; expires=${date.toUTCString()}`;
	}

	const { path = '/', sameSite = 'Lax', secure = false } = options;

	document.cookie =
		`${encodeURIComponent(name)}=${encodeURIComponent(value)}` +
		`${expires}; path=${path}; SameSite=${sameSite}` +
		`${secure ? '; Secure' : ''}`;
}

function readCookie(name) {
	const nameEQ = `${encodeURIComponent(name)}=`;

	const match = document.cookie
		.split(';')
		.map((c) => c.trim())
		.find((c) => c.startsWith(nameEQ));

	return match ? decodeURIComponent(match.substring(nameEQ.length)) : null;
}

function eraseCookie(name, options = {}) {
	createCookie(name, '', -1, options);
}

function format_phone(phone) {
	const usPhoneRegex = /^\+?1([2-9][0-8][0-9])([2-9][0-9][0-9])([0-9][0-9][0-9][0-9])$/;
	const intlPhoneRegex = /^\+?(2[07]|2[1-69][0-9]|3[0-469]|3[578][0-9]|4[013-9]|42[0-9]|5[09][0-9]|5[1-8]|6[0-6]|6[7-9][0-9]|7|8[1-46]|8[0578][0-9]|9[0-58]|9[679][0-9])(.*)$/;

	const digitsOnly = phone.replace(/[^0-9]/gi, '');

	const matchesUs = digitsOnly.match(usPhoneRegex);
	const matchesIntl = digitsOnly.match(intlPhoneRegex);

	if (matchesUs && matchesUs.length > 2) {
		return `+1 (${matchesUs[1]}) ${matchesUs[2]} ${matchesUs[3]}`;
	}

	if (matchesIntl && matchesIntl.length > 1) {
		return `+${matchesIntl[1]} ${matchesIntl[2]}`;
	}

	return digitsOnly;
}

function format_date(date) {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');

	return `${month}/${day}/${year}`;
}

function format_time(date) {
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');

	return `${hours}:${minutes}:${seconds}`;
}

function format_datetime(date) {
	return `${format_date(date)} ${format_time(date)}`;
}

function format_money(value, currency, cents, ratePrecision) {
	return format_money_str(':symbol:integer:point:decimals:minor_symbol:code', value, currency, cents, ratePrecision);
}

function format_money_str(formatString, rawValue, currencyArg, centsArg, ratePrecisionArg) {
	const currency = currencyArg || STORE.currency;
	const cents = centsArg || false;
	const ratePrecision = ratePrecisionArg || (currency.exponent ? currency.exponent : 2);

	const scale = 10 ** ratePrecision;
	const value = Math.round(parseFloat(rawValue) * scale) / scale;

	const [integerPart, decimalPart] = `${value}`.split('.');

	const components = {
		code: '',
		symbol: '',
		minor_symbol: '',
		integer: integerPart,
		point: decimalPart ? '.' : '',
		decimals: decimalPart || '',
	};

	if (cents) {
		if (currency.minor_symbol && !STORE.hide_currency_symbol) {
			components.minor_symbol = currency.minor_symbol;
		} else {
			return format_money_str(formatString, value / 100, currency, false, ratePrecision);
		}
	} else if (currency.symbol && !STORE.hide_currency_symbol) {
		const isNegative = components.integer.startsWith('-');
		const symbolIsShort = currency.symbol.length >= 1 && currency.symbol.length <= 2;

		if (isNegative && symbolIsShort) {
			components.symbol = `-${currency.symbol}`;
			components.integer = components.integer.slice(1);
		} else {
			components.symbol = currency.symbol + (currency.symbol.length > 2 ? ' ' : '');
		}
	} else {
		components.code = ` ${currency.code}`;
	}

	return formatString.replace(/:(\w+)/g, (match, key) =>
		components[key] !== undefined ? components[key] : ''
	);
}

function format_megabyte(value, forceGiga = false, forceMega = false) {
	return format_megabyte_str(':integer:point:decimals :code', value, forceGiga, forceMega);
}

function format_megabyte_str(formatStringArg, valueArg, forceGiga = false, forceMega = false) {
	const precision = 2;
	const scale = 10 ** precision;
	const round = (num) => Math.round(num * scale) / scale;

	const rawValue = parseFloat(valueArg);
	const useGiga = rawValue < 1000 ? forceGiga : !forceMega;

	const value = useGiga ? round(rawValue / 1024) : round(rawValue);
	const code = useGiga ? 'GB' : 'MB';

	const [integerPart, decimalPart] = `${value}`.split('.');

	const components = {
		integer: integerPart,
		point: decimalPart ? '.' : '',
		decimals: decimalPart || '',
		code,
	};

	return Object.entries(components).reduce(
		(result, [key, val]) => result.replace(`:${key}`, val),
		formatStringArg
	);
}

function hide_page_message(pageMessage) {
	pageMessage.style.opacity = '0';
	setTimeout(() => {
		pageMessage.remove();
	}, 500);
}

function show_page_message(message, className = '', duration = 10000) {
	const pageMessageHolder = document.getElementById('page_message_holder');
	if (!pageMessageHolder || !message) return;

	const pageMessage = document.createElement('div');
	pageMessage.classList.add('page_message');
	if (className !== '') {
		pageMessage.classList.add(className);
	}

	const messageWrapper = document.createElement('div');
	messageWrapper.classList.add('message_wrapper');

	const messageCloseBtn = document.createElement('button');
	messageCloseBtn.type = 'button';
	messageCloseBtn.innerText = '×';
	messageCloseBtn.addEventListener('click', () => {
		hide_page_message(pageMessage);
	});

	pageMessage.appendChild(messageWrapper);
	pageMessage.appendChild(messageCloseBtn);
	pageMessageHolder.appendChild(pageMessage);

	const messageContentLines = Array.isArray(message)
		? message
		: typeof message === 'object'
			? Object.values(message)
			: [message];

	messageWrapper.innerHTML = messageContentLines.join('<br>');

	setTimeout(() => {
		pageMessage.style.opacity = '1';

		if (duration) {
			setTimeout(() => {
				hide_page_message(pageMessage);
			}, duration);
		}
	}, 50);
}

function valid_email(address) {
	const regexCheck = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

	return regexCheck.test(address);
}

function validate_us_zip(value) {
	return /^(\d{5})(?:\s*-\s*(\d{4}))?$/.test(value);
}

function time_to_promo(element, text, timeUntil, serverTime, reRenderTimeout = 1000) {
	const targetElement = document.getElementById(element);
	if (!targetElement) return;

	let timer;
	const countDownDate = new Date(timeUntil).getTime();

	const renderCountDown = () => {
		const now = new Date(serverTime).getTime();
		const distance = countDownDate - now;

		if (distance <= 0) {
			clearInterval(timer);
			targetElement.innerHTML = `${text} 0d 0h 0m`;
			return;
		}

		const days = Math.floor(distance / (1000 * 60 * 60 * 24));
		const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

		targetElement.innerHTML = `${text} ${days}d ${hours}h ${minutes}m`;
	};

	// Render immediately so the element isn't blank while waiting for the first interval tick.
	renderCountDown();

	timer = setInterval(renderCountDown, reRenderTimeout);
}

function detectBrowserGPC() {
	if (!('globalPrivacyControl' in navigator)) {
		return 'not_supported';
	}

	return navigator.globalPrivacyControl ? 'enabled' : 'disabled';
}

/* --- File updated to ES6 until this line ---- */

document.addEventListener('DOMContentLoaded', () => {
	$('.modal-submit-timer').on('show.bs.modal', function () {
		let submit_timer;
		let remaining_seconds = 3;
		let submit = this.querySelector('[type=submit]');
		let initial_text = submit.innerHTML;

		submit.setAttribute('disabled', 'true');
		submit.innerHTML = remaining_seconds;

		submit_timer = setInterval(function () {
			submit.innerHTML = remaining_seconds;
			if (remaining_seconds == 0) {
				submit.removeAttribute('disabled');
				submit.innerHTML = initial_text;
				clearInterval(submit_timer);
			}

			remaining_seconds--;
		}, 1000);
	});

	if (document.querySelectorAll('[data-toggle=tooltip]')?.length) {
		$('body').tooltip({selector: '[data-toggle=tooltip]'});
	}

	const show_passwords = document.querySelectorAll('.toggle-password');
	if (show_passwords) {
		for (let i = 0; i < show_passwords.length; i++) {
			const current_element = show_passwords[i];
			current_element.addEventListener('click', function () {
				let use = this.querySelector('svg use');
				let password_input = this.parentElement.parentElement.parentElement.querySelector('input');
				if (use.href.baseVal === '#svg_password-show') {
					use.href.baseVal = '#svg_password-hide';
					password_input.type = 'password';
				} else {
					use.href.baseVal = '#svg_password-show';
					password_input.type = 'text';
				}
			});
		}
	}

	// Disable submit button on the id's first. Needs testing before activation on all forms.
	['#buy_form', '#account_login_form', '#recover_password', '#form_buy_payg'].forEach(selector => {
		const form = document.querySelector(selector);
		if (form) {
			form.addEventListener('submit', () => {
				form.querySelector('button[type=submit]:not([name])').disabled = true;
			});
		}
	});

	document.querySelectorAll('.dropdown-menu a').forEach(function (el) {
		el.addEventListener('click', (e) => e.stopPropagation());
		el.addEventListener('touchstart', (e) => e.stopPropagation(), { passive: true });
	});

	/* ADD main menu logic */
	// Note This is a fallback in case glyphicon doesn't change.
	$('.collapse').on('show.bs.collapse', function () {
		const trigger = document.querySelector('[data-target="#' + this.id + '"], div[href="#' + this.id + '"]');
		if (trigger) {
			trigger.classList.add('opened');
			trigger.querySelectorAll('.glyphicon-chevron-down').forEach(element => {
				element.classList.remove('glyphicon-chevron-down');
				element.classList.add('glyphicon-chevron-up');
			});
		}
	});

	$('.collapse').on('hide.bs.collapse', function () {
		const trigger = document.querySelector('[data-target="#' + this.id + '"], div[href="#' + this.id + '"]');
		if (trigger) {
			trigger.classList.remove('opened');
			trigger.querySelectorAll('.glyphicon-chevron-up').forEach(element => {
				element.classList.remove('glyphicon-chevron-up');
				element.classList.add('glyphicon-chevron-down');
			});
		}
	});

	document.querySelectorAll('.btn-on_off > .btn').forEach((el) => {
		el.addEventListener('click', () => {
			const button = el.closest('.on_off_settings_holder').querySelector('.btn-on_off_value');

			if (!button) {
				return;
			}

			if (el.getAttribute('data-on_off') == 'off') {
				button.querySelectorAll('option').forEach(option => {
					if (option.getAttribute('value') == '' || option.getAttribute('value') == 0) {
						button.value = option.getAttribute('value');
					}
				});
			}

			if (el.getAttribute('data-on_off') == 'on' && (button.value == 0 || button.value == '')) {
				button.querySelectorAll('option').forEach(option => {
					if (option.getAttribute('value') != '' && option.getAttribute('value') != 0) {
						button.value = option.getAttribute('value');
					}
				});
			}
		});
	});

	// used for checkout on pay as you go
	document.querySelectorAll('.btn-on_off_value').forEach((el) => {
		el.addEventListener('change', () => {
			const on_off_holder = el.closest('.on_off_settings_holder')?.querySelector('.btn-on_off');

			if (!on_off_holder) {
				return;
			}

			if (el.value != '' && el.value != 0) {
				on_off_holder.querySelector('label[data-on_off="on"]').click();
			} else {
				on_off_holder.querySelector('label[data-on_off="off"]').click();
			}
		});
	});

	document.querySelectorAll('.messages_holder .message_holder').forEach(el => {
		el.addEventListener('mouseenter', function () {
			clearTimeout(bannerAnimationTimer);
		});
		el.addEventListener('mouseleave', function () {
			bannerAnimationTimer = setTimeout(function () {
				repeat_banner();
			}, bannerAnimationCycle);
		});
	});

	bannerAnimationTimer = setTimeout(function () {
		repeat_banner();
	}, bannerAnimationCycle);

	if (flag_fix) {
		document.querySelector('body').classList.add('flag_fix');
	} else {
		document.querySelector('body').classList.remove('flag_fix');
	}

	function handleRowClick(event) {
		const row = event.target.closest('table.row_checkbox tr');
		if (!row) return;

		const input = row.querySelector('input[type=radio], input[type=checkbox]');
		if (!input) return;

		input.checked = true;
	}
	document.removeEventListener('click', handleRowClick);
	document.addEventListener('click', handleRowClick);

	document.getElementById('register_referral_trigger')?.addEventListener('click', (e) => {
		e.preventDefault();
		document.getElementById('register_referral_trigger_wrapper')?.classList.add('d-none');
		document.getElementById('register_referral_code_wrapper')?.classList.remove('d-none');
	});

	// TODO Replace tooltip from jquery with something else
	$('[rel=tooltip]:not(input)').tooltip();
	$('input[rel=tooltip]').tooltip({trigger: 'focus'});

	document.getElementById('coupon')?.addEventListener('keydown', function (event) {
		if (event.key === 'Enter') {
			document.getElementById('add_coupon_button').click();
		}
	});

	// update the states when selecting the country
	const country = document.getElementById('i_country');
	if (country) {
		country.addEventListener('change', (e) => {
			let country = e.target.value;
			let state_select = document.getElementById('i_state');
			let old_state_element = document.getElementById('i_other_state');
			let old_state = old_state_element?.value;
			let states = false;
			const form = e.target.closest('form');

			if (country == '') {
				old_state_element.classList.add('hidden');
				state_select.classList.add('hidden');
				if (form) {
					form.dispatchEvent(new CustomEvent('changeCountry', {
						detail: {hasStateSelector: false, isCountryEmpty: true}
					}));
				}
			} else {
				try {
					states = all_states[country];
				} catch (e) {
					console.warn('Missing country array.');
				}
				state_select.selectedIndex = 0;
				state_select.options.length = 1;
				if (states) {
					state_select.options[0].text = country == 'US' ? messages.SELECT_STATE_CHECKOUT : messages.SELECT_REGION;
					for (let i = 0; i < states.length; i++) {
						state_select.options[i + 1] = new Option(states[i][1], states[i][0]);
						if (old_state == states[i][0])
							state_select.selectedIndex = i + 1;
					}
					old_state_element.classList.add('hidden');
					state_select.classList.remove('hidden');
					state_select.focus();

					if (form) {
						form.dispatchEvent(new CustomEvent('changeCountry', {
							detail: {hasStateSelector: true, isCountryEmpty: false}
						}));
					}
				} else {
					state_select.classList.add('hidden');
					old_state_element.classList.remove('hidden');
					old_state_element.focus();

					if (form) {
						form.dispatchEvent(new CustomEvent('changeCountry', {
							detail: {hasStateSelector: false, isCountryEmpty: false}
						}));
					}
				}
			}
		});
		country.dispatchEvent(new Event('change', { bubbles: true }));
	}

	try {
		$('#currency_info').tooltip({title: messages.CURRENCY_INFO});
	} catch (error) {
		console.log(error);
	}

	document.querySelectorAll('.change_recurring_charge_custom_plan_form').forEach(element => {
		element.addEventListener('submit', (e) => {
			e.preventDefault();

			fetcher(e.target.getAttribute('action'), {
				method: 'POST',
				body: new FormData(e.target)
			}).ready.then((response) => {
				if (response) {
					show_page_message(it('CHANGES_SAVED_MESSAGE'), 'status_success');
				} else {
					show_page_message(it('ERROR_TRY_AGAIN'), 'status_error');
				}
			}).catch(() => {
				show_page_message(it('ERROR_TRY_AGAIN'), 'status_error');
			});
		});
	});

	document.querySelectorAll('.change_recurring_charge_custom_plan_trigger').forEach(element => {
		element.addEventListener('change', (e) => {
			e.target.closest('form').dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
		});
	});

	if (document.getElementById('form_register_new_account')) {
		const errorHandler = (input, errors, form, container) => {
			const parent = input.parentElement;
			if (errors) {
				if (parent.classList.contains('input-group')) {
					parent.insertAdjacentElement('afterend', container);
				} else if (input.getAttribute('name') === 'terms_and_conditions') {
					let parentElement = parent.parentNode;
					let label = parentElement.querySelector('label');
					label.insertAdjacentElement('afterend', container);
				} else {
					input.insertAdjacentElement('afterend', container);
				}
			}
		}
		const constraints = {
			first_name: {
				presence: {
					message: '^' + messages.ERROR_ENTER_FIRST_NAME
				}
			},
			last_name: {
				presence: {
					message: '^' + messages.ERROR_ENTER_LAST_NAME
				}
			},
			login: {
				presence: {
					message: '^' + messages.ERROR_PLEASE_ENTER_EMAIL
				},
				email: {
					message: '^' + messages.ERROR_INVALID_EMAIL
				}
			},
			password: {
				presence: {
					message: '^' + messages.ERROR_ENTER_PASSWORD
				},
				passwordStrongSecurity: true,
			},
			confirm_password: {
				presence: {
					message: '^' + messages.ERROR_ENTER_PASSWORD_AGAIN
				},
				equality: {
					attribute: "password",
					message: '^' + messages.ERROR_PASSWORD_MISMATCH
				}
			},
			terms_and_conditions: {
				inclusion: {
					within: [true],
					message: "^" + messages.MANDATORY_FIELD
				}
			}
		};

		const validator = new FormValidator({
			errorHandler,
			isInvalid: 'inputError'
		});
		validator.passwordStrongSecurityMeter('form_register_new_account', 'password');
		validator.start('form_register_new_account', constraints);
	}

	if (document.getElementById('alias_form')) {
		const aliasConstraints = {
			'nickname': {
				presence: true,
				requireonealpha: true,
			},
		}
		new FormValidator({isInvalid: 'inputError'}).start('alias_form', aliasConstraints);
	}

	$.validator.addMethod('username', function (value, element) {
		return this.optional(element) || /^[a-zA-Z0-9_.-]+$/.test(value);
	});
	$.validator.addMethod('phone', function (value, element) {
		return this.optional(element) || validate_phone_number(value)[0];
	});
	$.validator.addMethod('creditcard', function (value, element) {
		return this.optional(element) || validate_credit_card(value);
	});
	$.validator.addMethod('us_zip', function (value, element) {
		return this.optional(element) || validate_us_zip(value);
	}, jQuery.validator.format(messages.INVALID_ZIP_CODE));
	$.validator.addMethod('checkout_billing_zip', function (value, element) {
		if (element.closest('form').querySelector('[name="bill[country]"]')?.value === 'US') {
			return this.optional(element) || validate_us_zip(value);
		} else {
			return this.optional(element) || true;
		}
	}, jQuery.validator.format(messages.INVALID_ZIP_CODE));
	$.validator.addMethod('requireonealpha', function (value, element) {
		return this.optional(element) || /[a-z]+/i.test(value);
	}, jQuery.validator.format(messages.ERROR_MESSAGE_AT_LEAST_ONE_ALPHA));

	// TODO: instead of dataLayerPush use navigator send beacon when implementing serverside analytics
	document.addEventListener('click', (e) => {
		const element = e.target.closest('.js_analytics_click_event');
		if (!element) return;

		const dataset = element.dataset;
		const payload = {};

		if (dataset.event) {
			payload.event = dataset.event;
		} else {
			payload.event = 'trackEvent';
		}

		if (dataset.googleTagParams) {
			try {
				payload.google_tag_params = JSON.parse(dataset.googleTagParams);
			} catch (e) {
				console.error("Invalid JSON in google_tag_params:", dataset.googleTagParams);
			}
		}

		if (dataset.eventCategory) {
			payload.eventCategory = dataset.eventCategory;
		}

		if (dataset.eventAction) {
			payload.eventAction = dataset.eventAction;
		}

		if (dataset.eventLabel) {
			payload.eventLabel = dataset.eventLabel;
		}

		dataLayerPush(payload);
	});

	document.addEventListener('change', (e) => {
		const element = e.target.closest('.js_on_change_submit');
		if (!element) return;
		element.form.submit();
	});

	document.addEventListener('click', (e) => {
		const element = e.target.closest('.js_reload_page');
		if (!element) return;
		location.reload();
	});

	document.addEventListener('click', (e) => {
		const element = e.target.closest('.js_go_back');
		if (!element) return;
		history.go(-1);
	});

	/* eslint-enable consistent-return */
	/* general my account START */
	// maybe add a cancel trigger?
	document.querySelectorAll('.edit_form form').forEach(form => {
		form.addEventListener('reset', function () {
			const editFields = this.closest('.edit_fields');
			editFields.querySelectorAll('.edit_initial').forEach(el => {
				el.style.display = '';
				el.classList.remove('display_none', 'd-none');
			});
			editFields.querySelectorAll('.edit_form').forEach(el => el.classList.add('d-none'));
		});
	});

	document.querySelectorAll('.edit_fields .edit_trigger').forEach(trigger => {
		trigger.addEventListener('click', function () {
			const editFields = this.closest('.edit_fields');
			editFields.querySelectorAll('.edit_initial').forEach(el => el.classList.add('d-none'));
			editFields.querySelectorAll('.edit_form').forEach(el => {
				el.style.display = '';
				el.classList.remove('display_none', 'd-none');
			});
		});
	});

	try {
		const svg_common = new SvgCommon();

		const svg_why_logo_element = document.getElementById('why_logo');
		if (svg_why_logo_element) {
			svg_why_logo_element.appendChild(svg_common.cloneContent('svg_logo', 'svg_logo_bg_blue'));
		}

		const svg_trustpilot_element = document.querySelector('.new_trust_pilot');
		if (svg_trustpilot_element) {
			svg_trustpilot_element.appendChild(svg_common.cloneContent('svg_trustpilot-logo', 'svg_trustpilot_white'));
		}
	} catch (error) {}

	document.querySelectorAll('.table_filter select').forEach((element) => {
		element.value = '';
	});

	if (!STORE.is_new_validator) {
		$.extend(jQuery.validator.messages, {
			required: it('MANDATORY_FIELD'),
			remote: it('ERROR_EMAIL_ADDRESS_ALREADY_IN_USE'),
			email: it('CONTACT_NO_MSG_ERR'),
			url: it('ERROR_VALID_URL'),
			date: it('ERROR_VALID_DATE'),
			number: it('ERROR_VALID_NUMBER'),
			phone: it('ERROR_VALID_NUMBER'),
			digits: it('ERROR_ENTER_DIGITS_ONLY'),
			creditcard: it('INVALID_CARD_NUMBER'),
			equalTo: it('ERROR_ENTER_EMAIL_ADDRESS_AGAIN'),
			rangelength: it('ERROR_ENTER_TEXT_BETWEEN'),
			maxlength: it('ERROR_ENTER_MAX_LENGTH'),
			minlength: it('ERROR_ENTER_MIN_LENGTH'),
			max: it('ERROR_ENTER_VALUE_LESS_EQUAL_TO'),
			min: it('ERROR_ENTER_VALUE_GREATER_EQUAL_TO'),
			range: it('ENTER_VALUE_CHARACTERS'),
		});
		$.extend(jQuery.validator.prototype, {
			focusInvalid: function () {
				if (this.settings.focusInvalid) {
					try {
						$(this.findLastActive() || this.errorList.length && this.errorList[0].element || [])
							.filter(':visible')
							.focus()
							// manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
							.trigger('focusin');
						first_invalid_element = $(this.findLastActive() || this.errorList.length && this.errorList[0].element || []);
						menu_height = $('#main_menu').outerHeight(true);
						if (first_invalid_element.offset().top - $(window).scrollTop() < 70) {
							$(window).scrollTop(first_invalid_element.offset().top - menu_height - 50);
						}
					} catch (e) {
						// ignore IE throwing errors when focusing hidden elements
					}
				}
			}
		});
	}

	document.querySelectorAll('.input-group .btn-copy')?.forEach(btn_copy => {
		const input_copy = btn_copy.closest('.input-group').querySelector('.input-copy');
		if (input_copy) {
			btn_copy.addEventListener('click', () => {
				try {
					input_copy.select();
					input_copy.setSelectionRange(0, input_copy.value.length);
					navigator.clipboard.writeText(input_copy.value).then(() => {
						input_copy.blur();
						const icon_holder = btn_copy.querySelector('.glyphicon');
						if (icon_holder) {
							icon_holder.classList.remove('glyphicon-duplicate');
							icon_holder.classList.add('glyphicon-ok');

							setTimeout(() => {
								icon_holder.classList.remove('glyphicon-ok');
								icon_holder.classList.add('glyphicon-duplicate');
							}, 3000);
						}
					})
				} catch (e) {
					console.error(e);
				}
			});
		}
	});

	(function () {
		function handleEnterKey(event) {
			if (event.key === 'Enter') {
				const inputElement = event.target;
				const targetSelector = inputElement.getAttribute('data-on-enter-click');
				if (targetSelector) {
					const targetElement = document.querySelector(targetSelector);
					if (targetElement && !targetElement.disabled) {
						event.preventDefault();
						targetElement.click();
					}
				}
			}
		}

		document.querySelectorAll('input[data-on-enter-click]').forEach(input => {
			input.addEventListener('keydown', handleEnterKey);
		});
	})();

	window.dispatchEvent(new Event('scroll', {
		bubbles: true,
		cancelable: false,
	}));

	if (global_message && (_page_name !== 'subscribe' || !('success' in global_message))) {
		show_page_message(global_message);
	}

	if (global_v3_success_message && _page_name !== 'subscribe') {
		show_page_message(global_v3_success_message, 'status_success');
	}

	if (global_v3_error_message) {
		show_page_message(global_v3_error_message, 'status_error');
	}

	if (global_v3_notice_message) {
		show_page_message(global_v3_notice_message, 'status_notice');
	}

	if (global_v3_warning_message) {
		show_page_message(global_v3_warning_message, 'status_warning');
	}

	if (typeof HelpCenterWidget !== 'undefined' && !['help_center', 'account/checkout', 'chat/window', 'chat/prepare'].includes(_page_name)) {
		try {
			new HelpCenterWidget({page_name: _page_name});
		} catch (e) {
			console.error(e);
			const answer_holder = document.getElementById('answer_holder');
			if (answer_holder) {
				answer_holder.insertAdjacentHTML('beforeend', `<div class='padding15'><p>${it('SOCIAL_LOGIN_ERROR')}</p></div>`);
			}
		}
	}

	if (_url_is_ssl) {
		document.querySelectorAll('#form_newsletter, #footer_form_newsletter').forEach(form => {
			form.addEventListener('submit', (event) => {
				event.preventDefault();

				let messageHolder;
				if ('footer_form_newsletter' === form.id) {
					messageHolder = '#form_footer_newsletter_message';
				} else {
					messageHolder = '#form_newsletter_message';
				}
				const messageHolderElement = document.querySelector(messageHolder);
				messageHolderElement.classList.add('hidden');
				messageHolderElement.classList.remove('alert', 'alert-danger', 'alert-success');
				messageHolderElement.innerHTML = '';

				if (form.querySelector('input[name=email]').value.length > 5) {
					form.querySelector('.spinner')?.classList.remove('hidden');

					fetcher(url('/process_newsletter'), {
						method: 'post',
						body: new FormData(form)
					}).ready.then((response) => {
						form.querySelector('.spinner')?.classList.add('hidden');
						messageHolderElement.classList.remove('hidden');

						if (response.error) {
							messageHolderElement.classList.add('alert', 'alert-danger');
							messageHolderElement.innerHTML = response.error;
						} else if (response.success) {
							messageHolderElement.classList.add('alert', 'alert-success');
							messageHolderElement.innerHTML = response.success;
						}
					});
				}
			});
		});
	}

	if (is_Android) {
		try {
			Android.closeWindow();
		} catch (error) {
		}
	} else if (is_iOSwebview) {
		window.location.hash = 'iosClosewindow';
	}

	try {
		const _trigger_params = ['src', 'utm_source', 'utm_medium', 'utm_campaign'];
		let _contains_trigger = false;
		const _active_days = 30;
		for (let __i = _trigger_params.length - 1; __i >= 0; --__i) {
			if (window.location.href.indexOf(_trigger_params[__i]) !== -1) {
				_contains_trigger = true;
			}
		}
		if (STORE.user_is_logged_in) {
			if (readCookie('DCM3new')) {
				eraseCookie('DCM3new');
			}
			if (!readCookie('DCM3exist')) {
				createCookie('DCM3exist', 'active', _active_days);
			}
		}
		if (!readCookie('DCM3exist')) {
			if (readCookie('DCM3new')) {
				const _existing_val = readCookie('DCM3new');
				const _new_val = parseInt(_existing_val) + 1;
				if (_new_val >= 3) {
					dataLayerPush({'event': 'dcmCustomer3Pages'});
					createCookie('DCM3exist', 'active', _active_days);
				} else {
					createCookie('DCM3new', _new_val, _active_days);
				}
			} else {
				if (_contains_trigger) {
					createCookie('DCM3new', 1, _active_days);
				}
			}
		}
	} catch (error) {
		console.log('DCM 3 page error: ', error);
	}

	const footerOverlay = document.getElementById('footer_overlay');
	const toggleButton = document.getElementById('consent-options');
	if (toggleButton) {
		const mainButtons = footerOverlay.querySelector('.main-buttons');
		const buttonGroups = mainButtons.querySelectorAll('.buttons-group');
		const mainText = footerOverlay.querySelector('.js-consent-main-text');
		const subText = footerOverlay.querySelector('.js-consent-sub-text');

		const observer = new MutationObserver((mutations) => {
			mutations.forEach(function (mutation) {
				if (mutation.attributeName === 'aria-expanded') {
					if (toggleButton.getAttribute('aria-expanded') === 'true') {
						buttonGroups.forEach((element) => {
							mainButtons.classList.add('hide-space-on-mobile');
							element.classList.add('hide-buttons-group');
						});
						if (mainText && subText) {
							mainText.classList.add('display_none');
							subText.classList.remove('display_none');
						}
					} else {
						buttonGroups.forEach((element) => {
							mainButtons.classList.remove('hide-space-on-mobile');
							element.classList.remove('hide-buttons-group');
						});
						if (mainText && subText) {
							subText.classList.add('display_none');
							mainText.classList.remove('display_none');
						}
					}
				}
			});
		});

		observer.observe(toggleButton, { attributes: true });
	}

	try {
		scrollToTargetFromUrl();
	} catch (error) {
		console.warn('Error while trying to scroll: ', error);
	}

	document.querySelectorAll('.panel-heading').forEach(faqPanelHeading => {
		faqPanelHeading.addEventListener('click', () => {
			setTimeout(() => {
				const rect = faqPanelHeading.getBoundingClientRect();
				const stickyNav = document.getElementById('main_menu');
				const navHeight = stickyNav ? stickyNav.offsetHeight : 0;
				const totalOffset = navHeight + 15;
				const isAboveViewport = rect.top < totalOffset;
				const isBelowViewport = rect.bottom > (window.innerHeight || document.documentElement.clientHeight);

				if (isAboveViewport || isBelowViewport) {
					scrollToAnchor(faqPanelHeading, totalOffset);
				}
			}, 450);
		});
	});
});

let pendingTarget = null;

['click', 'touchstart'].forEach(eventType => {
	document.addEventListener(eventType, function (e) {
		const target = e.target.closest('.confirm, .btn-confirm');

		if (target && document.contains(target)) {
			if (target.getAttribute('data-confirmed') === 'true') {
				target.removeAttribute('data-confirmed');
				return;
			}
			e.preventDefault();
			pendingTarget = target;
			const message = target.getAttribute('data-confirm_message') || it('ARE_YOU_SURE');
			document.getElementById('global_confirm_message').textContent = message;
			$('#global_confirm_modal').modal('show');
		}
	});
});

document.getElementById('global_confirm_btn').addEventListener('click', function () {
	if (pendingTarget) {
		$('#global_confirm_modal').modal('hide');
		pendingTarget.setAttribute('data-confirmed', 'true');
		pendingTarget.click();
		pendingTarget = null;
	}
});

$('#global_confirm_modal').on('hidden.bs.modal', function () {
	pendingTarget = null;
});

document.addEventListener('input', function (event) {
	if (event.target.matches('.numbers-only')) {
		event.target.value = event.target.value.replace(/[^0-9]/g, '')
	}
});

// start/stop animations based on tab visibility
var hidden, visibility_change;
if (typeof document.hidden !== 'undefined') {
	hidden = 'hidden';
	visibility_change = 'visibilitychange';
} else if (typeof document.mozHidden !== 'undefined') {
	hidden = 'mozHidden';
	visibility_change = 'mozvisibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
	hidden = 'msHidden';
	visibility_change = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
	hidden = 'webkitHidden';
	visibility_change = 'webkitvisibilitychange';
}

function repeat_banner() {
	document.querySelectorAll('.messages_holder').forEach((container, i) => {
		let holder = container.querySelectorAll('.message_holder:not(.downtime)');
		if (holder.length > 1) {
			let active_holder = document.querySelector('.message_holder.active');
			let active_banner = active_holder ? Array.prototype.indexOf.call(active_holder.parentElement.children, active_holder) : -1;
			active_banner++;
			active_banner = active_banner % holder.length;
			holder.forEach(e => {
				e.classList.add('none');
				e.classList.remove('active');
			});

			container.querySelectorAll('.message_holder:nth-child(' + (active_banner + 1) + ')').forEach(e => {
				e.classList.remove('none');
				e.classList.add('active');
			});

			bannerAnimationTimer = setTimeout(function () {
				repeat_banner();
			}, bannerAnimationCycle);
		}
	});
}

function get_form_security_fields() {
	const nothing_name = document.querySelector('form input[name^=_nothing_]')?.name;

	const security_fields = {
		_snowman: encodeURI('☃'),
		_token: document.querySelector('form input[name=_token]')?.value,
	};
	security_fields[nothing_name] = '';

	return security_fields;
}

function form_security_fields(original_uri, token_value, nothing_name) {
	let has_token = false;
	let has_nothing = false;
	let has_snowman = false;
	let security_fields = [];
	let uri = original_uri.split('&');

	uri.forEach(function (attributes) {
		attributes = attributes.split('=');
		if (attributes[0] === '_token' && decodeURIComponent(attributes[1]) === token_value) {
			has_token = true;
		}
		if (attributes[0] === nothing_name && attributes[1] === '') {
			has_nothing = true;
		}
		if (attributes[0] === '_snowman' && decodeURIComponent(attributes[1]) === '☃') {
			has_snowman = true;
		}
	});

	if (!has_token) {
		security_fields.push('_token=' + token_value);
	}
	if (!has_nothing) {
		security_fields.push(nothing_name + '=');
	}
	if (!has_snowman) {
		security_fields.push('_snowman=☃');
	}

	if (original_uri.length > 0) {
		original_uri += '&';
	}

	if (security_fields.length !== 0) {
		console.log('form_security_fields() adding needed fields');
		original_uri += encodeURI(security_fields.join('&'));
	}

	return original_uri;
}

/* settings ajaxSetup as default/fallbackup settings */
$.ajaxSetup({
	url: '/',
	type: 'post',
	dataType: 'json',
	data: {},
	beforeSend: function (jqXHR, settings) {
		if (settings.type === 'POST') {
			let token_value = $('form input[name=_token]').val();
			let nothing_name = $('form input[name^=_nothing_]').attr('name');

			settings.data = form_security_fields(settings.data, token_value, nothing_name);
		}
	},
	success: function (data, textStatus, jqXHR) {
		console.log(data, textStatus, jqXHR);
	},
	error: function (jqXHR, textStatus, errorThrown) {
		console.log(jqXHR, textStatus, errorThrown);
	}
});

$.validator.setDefaults({
	debug: false,
	errorClass: 'inputError',
	submitHandler: function (form) {
		$(':submit', form).attr({'disabled': true});
		form.submit();
	}
});
(function ($) {
	$.fn.removeClassRegEx = function (regex) {
		let classes = $(this).attr('class');

		if (!classes || !regex)
			return false;

		let classArray = [];
		classes = classes.split(' ');

		for (let i = 0, len = classes.length; i < len; i++)
			if (!classes[i].match(regex))
				classArray.push(classes[i]);

		$(this).attr('class', classArray.join(' '));

		return $(this);
	};
})(jQuery);

(function ($) {
	$.fn.getCursorPosition = function () {
		let input = this.get(0);
		if (!input) return 0; // No (input) element found
		if ('selectionStart' in input) {
			// Standard-compliant browsers
			return input.selectionStart;
		} else if (document.selection) {
			// IE
			input.trigger('focus');
			let sel = document.selection.createRange();
			let selLen = document.selection.createRange().text.length;
			sel.moveStart('character', -input.value.length);

			return sel.text.length - selLen;
		}

		return 0;
	};
})(jQuery);

function validate_phone_number(phone) {
	let ext, match, us_re, intl_re, try_us = true, try_intl = true, valid = false;

	// disabled the validation for now:
	return [$.trim(phone) != '', phone];

	// phone = phone.replace(/[^0-9x+]/g, '');
	// if (phone) {
	// 	phone = phone.replace(/^\+?(011|00)/, '+');
	// 	match = /^(\+?[0-9]+)(x([0-9]+))?$/.exec(phone);
	// 	if (match && match[1].length >= 6 && match[1].length <= 16) {
	// 		phone = match[1];
	// 		ext = match[3];
	// 		us_re = /^([2-9][0-8][0-9])([2-9][0-9][0-9])([0-9][0-9][0-9][0-9])$/;
	// 		// intl_re = /^\+?(2[07]|2[1-69][0-9]|3[0-469]|3[578][0-9]|4[013-9]|42[0-9]|5[09][0-9]|
	// 		//5[1-8]|6[0-6]|6[7-9][0-9]|7|8[1-46]|8[0578][0-9]|9[0-58]|9[679][0-9])(.*)$/;
	// 		match = /^\+?1(.*)/.exec(phone);
	// 		if (match) {
	// 			phone = match[1];
	// 			try_intl = false;
	// 		}
	// 		if (try_us) {
	// 			match = us_re.exec(phone);
	// 			if (match) {
	// 				phone = '+1 (' + match[1] + ') ' + match[2] + ' ' + match[3];
	// 				valid = true;
	// 			}
	// 		}
	// 		if (!valid && try_intl) {
	// 			match = intl_re.exec(phone);
	// 			if (match) {
	// 				phone = '+' + match[1] + ' ' + match[2];
	// 				valid = true;
	// 			}
	// 		}
	// 		if (valid) {
	// 			phone = phone + (ext ? ' x ' + ext : '');
	// 		}
	// 	}
	// }

	// return [valid, phone];
}

function validate_credit_card(number) {
	/* TODO payment processor should be the source of truth for validation */
	const formats = [
		['2[2-7]', 16],			// Mastercard
		['5[1-5]', 16],			// Mastercard
		['3[47]', 15],			// American Express
		['6011|64[4-9]|65', 16], // Discover
		['6011|64[4-9]|65', 19], // Discover
		['2131|1800|35', 16],	// JCB
		['4', 13],				// Visa
		['4', 16],				// Visa
		['4', 19]				// Visa
	];

	number = number.replace(/[^0-9]/g, '');

	let valid = false;
	for (let i = 0; i < formats.length; i++) {
		if (number.length == formats[i][1] && number.match(new RegExp('^(' + formats[i][0] + ')')))
			valid = true;
	}
	if (!valid)
		return false;

	// luhn check
	const parity = number.length % 2;
	let total = 0;
	for (let i = 0; i < number.length; i++) {
		let digit = parseInt(number.charAt(i));
		if (i % 2 == parity) {
			digit *= 2;
			if (digit > 9)
				digit -= 9;
		}
		total += digit;
	}

	return total % 10 == 0;
}

function track_custom_plan(preselected_values) {
	let preselected_data = preselected_values ? preselected_values.mobile_data : null;
	let preselected_voice = preselected_values ? preselected_values.mobile_voice : null;
	let preselected_sms = preselected_values ? preselected_values.mobile_sms : null;

	document.querySelector('#buy_form button[type="submit"]').addEventListener('click', () => {
		let selected_data = document.querySelector('div[data-product_type=mobile_data] .swiper-slide.active')?.dataset.amount;
		let selected_voice = document.querySelector('div[data-product_type=mobile_voice] .swiper-slide.active')?.dataset.amount;
		let selected_sms = document.querySelector('div[data-product_type=mobile_sms] .swiper-slide.active')?.dataset.amount;

		if (typeof selected_sms === 'undefined') {
			selected_sms = 'unlimited';
		}

		let action = '';
		let label = '';
		let fixed_values = [selected_data, selected_voice, selected_sms, preselected_data, preselected_voice, preselected_sms];
		let arr = fixed_values.map(amount => {
			if (amount === null || amount === 'none') {
				return 0;
			}

			if (amount == 0 || typeof amount === 'string' && amount.toLowerCase() === 'unlimited') {
				return Infinity;
			}

			return parseInt(amount);
		});

		selected_data = arr[0];
		selected_voice = arr[1];
		selected_sms = arr[2];
		let _preselected_data = arr[3];
		let _preselected_voice = arr[4];
		let _preselected_sms = arr[5];

		if (_preselected_data === selected_data) {
			action += 'Equal Data';
			label += '';
		} else if (_preselected_data < selected_data) {
			action += 'Upgraded Data';
			label += 'DATA ' + _preselected_data + ' to ' + selected_data;
		} else if (_preselected_data > selected_data) {
			action += 'Downgraded Data';
			label += 'DATA ' + _preselected_data + ' to ' + selected_data;
		}

		if (_preselected_voice === selected_voice) {
			action += ' Equal Voice';
			label += '';
		} else if (_preselected_voice < selected_voice) {
			action += ' Upgraded Voice';
			label += ' VOICE ' + _preselected_voice + ' to ' + selected_voice;
		} else if (_preselected_voice > selected_voice) {
			action += ' Downgraded Voice';
			label += ' VOICE ' + _preselected_voice + ' to ' + selected_voice;
		}

		if (typeof document.querySelector('div[data-product_type=mobile_sms] .swiper-slide.active')?.dataset.amount !== 'undefined') {
			if (_preselected_sms === selected_sms) {
				action += ' Equal SMS';
				label += '';
			} else if (_preselected_sms < selected_sms) {
				action += ' Upgraded SMS';
				label += ' SMS ' + _preselected_sms + ' to ' + selected_sms;
			} else if (_preselected_sms > selected_sms) {
				action += ' Downgraded SMS';
				label += ' SMS ' + _preselected_sms + ' to ' + selected_sms;
			}
		}

		trackEvent('Custom Plan Progression', action.trim(), label.trim());
	});
}

var track_video_gtm = function () {
	if (typeof dataLayer !== 'undefined' || typeof ga !== 'undefined' || typeof _gaq !== 'undefined') {
		var gtmYTListeners = [];
		window.onYouTubeIframeAPIReady = function () {
			for (let e = document.getElementsByTagName('iframe'), x = e.length; x--;) {
				if (/youtube.com\/embed/.test(e[x].src)) {
					gtmYTListeners.push(new YT.Player(e[x], {
						events: {onStateChange: onPlayerStateChange}
					}));
					YT.gtmLastAction = 'p';
				}
			}
		};
		window.onPlayerStateChange = function (e) {
			e['data'] == YT.PlayerState.PLAYING && setTimeout(onPlayerPercent, 1000, e['target']);
		};
		window.onPlayerPercent = function (e) {
			if (e['getPlayerState']() == YT.PlayerState.PLAYING) {
				let t = e['getDuration']() - e['getCurrentTime']() <= 1.5 ? 1 : (Math.floor(e['getCurrentTime']() / e['getDuration']() * 4) / 4).toFixed(2);
				if (!e['lastP'] || t > e['lastP']) {
					let extra_data = e['getIframe']().getAttribute('data-video_label');
					let extra_info;
					if (extra_data) {
						extra_info = extra_data + ' - ';
					} else {
						extra_info = '';
					}
					let video_data = e['getVideoData'](),
						label = video_data.title;
					e['lastP'] = t;
					let action = '';
					if (t == 0) {
						action = 'Video Played';
					} else {
						action = t * 100 + '% Played';
					}
					if (typeof dataLayer !== 'undefined') {
						dataLayer.push({
							'event': 'trackEvent',
							'eventCategory': 'Youtube Videos',
							'eventAction': action,
							'eventLabel': extra_info + label
						});
					}
					if (typeof ga !== 'undefined') {
						// ga('send', 'event', 'Youtube Videos', action, label);
					}
					if (typeof _gaq !== 'undefined') {
						// _gaq.push(['_trackEvent', 'Youtube Videos', action, label]);
					}
				}
				e['lastP'] != 1 && setTimeout(onPlayerPercent, 1000, e);
			}
		};
		let j = document.createElement('script'),
			f = document.getElementsByTagName('script')[0];
		j.src = '//www.youtube.com/iframe_api';
		j.async = true;
		f.parentNode.insertBefore(j, f);
	}
};

function isInternetExplorer() {
	const ua = window.navigator.userAgent;
	const msie = ua.indexOf('MSIE ');
	const edge = ua.indexOf('Edge');

	return !!(msie > 0 || edge > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./));
}

function getSpinner() {
	if (isInternetExplorer()) {
		return '<img src="' + url('/images/spinner.gif') + '" class="height100 width100">';
	}

	return '<img src="' + url('/images/spinner.svg') + '" class="height100 width100">';
}

/* general my account settings START */
var account = {};
account.my_settings = (o) => {
	console.log('account.my_settings(%o)', o);
	if (o.mobile_credit) {
		document.addEventListener('click', (e) => {
			if (e.target.matches('.modify_auto_recharge')) {
				e.preventDefault();
				showAutoRechargeForm();
			}
			if (e.target.matches('.cancel_auto_recharge_form')) {
				e.preventDefault();
				hideAutoRechargeForm();
			}
		});

		document.addEventListener('change', (e) => {
			if (e.target.matches('.btn-on_off_value')) {
				let message_holder = document.querySelector('.auto_recharge_text');
				if (!message_holder) {
					return;
				}

				let new_value = document.querySelector('.btn-on_off_value')?.value;
				if (parseInt(new_value) === 0) {
					message_holder.innerHTML = it('TELLO_MY_ACCOUNT_AUTO_TOP_UP_MESSAGE', {
						'min_amount': format_money(o.mobile_credit.ar_min_amount)
					});
				} else {
					message_holder.innerHTML = it('TELLO_MY_ACCOUNT_AUTO_TOP_UP', {
						'selected_amount': format_money(new_value),
						'min_amount': format_money(o.mobile_credit.ar_min_amount)
					});
				}

			}
		});

		document.querySelectorAll('#auto_recharge_form .btn-on_off:not(.parent-btn-on_off)').forEach(el => {
			el.addEventListener('change', e => {
				e.preventDefault();
				e.stopPropagation();

				let _checked_radio = el.querySelector('input:checked');
				let _amount_select = document.querySelector('.btn-on_off_value');
				_amount_select.querySelector('option').selected = false;

				if (_checked_radio.value !== '1') {
					_amount_select.querySelector('option[value=10]').selected = true;
				}
			});
		});

		document.querySelectorAll('#auto_recharge_form .btn-on_off > .btn').forEach(el => {
			el.addEventListener('click', e => {
				e.preventDefault();
				let on_off_value_holder = document.querySelector('.btn-on_off_value');
				let on_of_value = on_off_value_holder.value;

				if (el.getAttribute('data-on_off') === 'off' && !el.classList.contains('active')) {
					on_off_value_holder.querySelectorAll('option').forEach((option) => {
						if (option.value === '' || parseInt(option.value) === 0) {
							on_off_value_holder.value = option.value;
						}
					});

					document.getElementById('auto_recharge_form').submit();
					hideAutoRechargeForm();
				}
				if (el.getAttribute('data-on_off') === 'on' && (parseInt(on_of_value) === 0 || on_of_value === '')) {
					document.querySelector('.auto_recharge_text').appendChild(getModifyLink());

					on_off_value_holder.querySelectorAll('option').forEach((option) => {
						if (option.value !== '' && parseInt(option.value) !== 0) {
							on_off_value_holder.value = option.value;
						}
					});

					showAutoRechargeForm();
				}
			});
		});

		document.querySelectorAll('#change_data_usage .btn-on_off:not(.parent-btn-on_off)').forEach(el => {
			el.addEventListener('click', (e) => {
				if (!e.target.querySelector('input').checked) {
					e.target.querySelector('input').checked = true;
					document.getElementById('change_data_usage').submit();
				}
			});
		});

		document.querySelectorAll('#change_international_roaming_status_form .btn-on_off:not(.parent-btn-on_off)').forEach(el => {
			el.addEventListener('click', (e) => {
				if (!e.target.querySelector('input').checked) {
					e.target.querySelector('input').checked = true;
					document.getElementById('change_international_roaming_status_form').submit();
				}
			});
		});

		document.querySelector('.save_auto_recharge_form')?.addEventListener('click', (e) => {
			e.preventDefault();
			document.getElementById('auto_recharge_form').submit();
		});
	}

	if (o.mobile_msisdn) {
		document.querySelectorAll('#text_settings .btn-on_off:not(.parent-btn-on_off)').forEach(el => {
			el.addEventListener('click', (e) => {
				if (!e.target.querySelector('input').checked) {
					e.target.querySelector('input').checked = true;
					document.getElementById('text_settings').submit();
				}
			});
		});
	}

	const showAutoRechargeForm = () => {
		let modify_button = document.querySelector('.modify_auto_recharge');
		let auto_holder = document.querySelector('.auto_holder');
		let buttons = document.querySelector('.auto_recharge_buttons');

		modify_button.classList.add('hidden');
		auto_holder.classList.remove('hidden');
		buttons.classList.remove('hidden');
		document.querySelector('.btn-on_off_value')?.dispatchEvent(new Event('change', { bubbles: true }));
	}

	const hideAutoRechargeForm = () => {
		let _auto_holder = document.querySelector('.auto_holder');
		let _autorecharge_texts = document.querySelector('.auto_recharge_text');
		let _buttons = document.querySelector('.auto_recharge_buttons');
		let on_off_value_holder = document.querySelector('.btn-on_off_value');
		let original_value = document.querySelector('.original_value')?.value;
		_auto_holder.classList.add('hidden');
		_buttons.classList.add('hidden');

		if (!original_value) {
			original_value = 10;
		}

		on_off_value_holder?.querySelectorAll('option').forEach((option) => {
			if (option.value == original_value) {
				on_off_value_holder.value = option.value;
			}
		});

		on_off_value_holder?.dispatchEvent(new Event('change', { bubbles: true }));
		_autorecharge_texts.append(getModifyLink());
	}

	const getModifyLink = () => {
		const modify_link = document.createElement('a');
		modify_link.classList.add('modify_auto_recharge', 'btn', 'btn-link', 'btn-inline-link');
		modify_link.text = it('EDIT');
		modify_link.href = '#';

		return modify_link;
	}
};
/* general my account END */

function cumulativeOffset(element) {
	let top = 0, left = 0;
	do {
		top += element.offsetTop || 0;
		left += element.offsetLeft || 0;
		element = element.offsetParent;
	} while (element);

	return {
		top: top,
		left: left
	};
}

function calculate_new_widget_height(element, relative_to) {
	const top_offset = cumulativeOffset(element).top;
	const relative_to__height = relative_to.offsetHeight;
	const real_top_offset = top_offset - relative_to__height - 485;

	return {
		holder_height: 475 + real_top_offset,
		answer_holder_height: 335 + real_top_offset,
		contact_holder_height: 475 - 30 + real_top_offset,
		offset_top: real_top_offset
	};
}

function submitForm(action, fields = []) {
	const form = document.createElement('form');
	form.action = action;
	form.method = 'post';

	const form_security_fields = get_form_security_fields();
	for (let name in form_security_fields) {
		const field = document.createElement('input');
		field.type = 'hidden';
		field.name = name;
		field.value = form_security_fields[name];
		form.appendChild(field);
	}

	fields.forEach(field => {
		const i_field = document.createElement('input');
		i_field.type = field.type;
		i_field.name = field.name;
		i_field.value = field.value;
		form.appendChild(i_field);
	});

	document.querySelector('body').appendChild(form);
	form.submit();
}

/**
 * Returns the CC type
 *
 * @param {string}   val      CC number
 *
 * @return {string}  If matched, returns the CC type
 */
function cardType(val) {
	let _type = '';
	if (val && val.length > 1) {
		if (val.match(/^2[2-7]/) || val.match(/^5[1-5]/)) {
			_type = 'mastercard';
		} else if (val.match(/^3[47]/)) {
			_type = 'american_express';
		} else if (val.match(/^6(011|4[4-9]|5)/)) {
			_type = 'discover';
		} else if (val.match(/^(2131|1800|35)/)) {
			_type = 'jcb';
		} else if (val.match(/^4/)) {
			_type = 'visa';
		}
	}

	return _type;
}

function updateBroadbandCardDetails(pack, element_id = 'broadband_details', autumnOffer = false, promo_oct2026 = false) {
	try {
		const content = document.getElementById(element_id);
		if (!content) {
			return;
		}

		const container = content.closest('.broadband_container');
		if (!container) {
			return;
		}

		if (container.classList.contains('broadband_button')) {
			const broadband_link = container.querySelector('a');
			const broadband_disabled = !pack?.product_data || !pack?.product_data?.fcc_uid;
			container.disabled = broadband_disabled;

			if (broadband_disabled) {
				broadband_link.removeAttribute('href');
				broadband_link.setAttribute('aria-disabled', 'true');
			} else {
				broadband_link.href = url(`/broadband_facts/${pack?.product_data?.fcc_uid ?? ''}`);
				broadband_link.removeAttribute('aria-disabled');
			}

			return;
		}

		let display_amount = 0;
		const mobile_data = pack?.pack_products?.reduce((carry, product) => {
			if (product.product_data.display_amount) {
				display_amount = product.product_data.display_amount;
			}

			return product.type === 'mobile_data' ? product : carry;
		}, null);

		if (!mobile_data) {
			container.classList.add('disabled');
			$(content).collapse('hide');
			return;
		}

		container.classList.remove('disabled');

		const plan_price_max_discount = parseFloat(pack?.max_discount);
		const is_promo = plan_price_max_discount > 0;
		const plan_price = is_promo ? parseFloat(pack?.price - plan_price_max_discount) : parseFloat(pack?.price);
		const plan_recurring_price = pack?.recurring_product ? parseFloat(pack?.recurring_product.price) : 0;
		const mobile_data_amount = mobile_data ? mobile_data['translated_name'] : '';
		const has_unlimited_mobile_data = mobile_data ? mobile_data['product_data']['amount'] === 0 : false;

		content.querySelector('.js-plan-name').innerHTML = pack?.pack_name;
		content.querySelector('.js-plan-price').innerHTML = format_money(plan_price, __currency);
		content.querySelector('.js-fcc-uid').innerHTML = pack?.product_data?.fcc_uid;
		content.querySelector('.js-mobile-data-amount').innerHTML = mobile_data_amount;
		content.querySelector('.js-mobile-data-unlimited').innerHTML = it('FCC_BROADBAND_SECTION_6_INFO_3', {
			display_amount: format_megabyte(display_amount),
		});
		content.querySelector('.js-mobile-data-unlimited').classList.toggle('hidden', !has_unlimited_mobile_data);
		content.querySelector('.js-mobile-data-amount').classList.toggle('hidden', has_unlimited_mobile_data);

		const promo_container = content.querySelector('.js-broadband-promo');
		const non_promo_container = content.querySelector('.js-broadband-normal');

		if (is_promo) {
			promo_container.querySelector('.js-promo-real-price').innerHTML = format_money(plan_recurring_price, __currency);
			promo_container.classList.remove('hidden');
			non_promo_container.classList.add('hidden');

			const unlimitedData = pack.pack_products.some(item => item.language_variable === 'UNLIMITED_DATA');
			const promoTime = promo_container.querySelector('.js-promo-time');

			// Time the introductory rate applies: 'time variable'
			if (unlimitedData) {
				if (autumnOffer) {
					promoTime.innerHTML = it('UNLIMITED_FIRST_6MONTHS');
				} else if (promo_oct2026) {
					promoTime.innerHTML = it('3_MONTHS');
				} else {
					promoTime.innerHTML = it('FCC_BROADBAND_PROMO_TIME');
				}
			} else if (autumnOffer) {
				promoTime.innerHTML = it('UNLIMITED_FIRST_6MONTHS');
			} else if (promo_oct2026) {
				promoTime.innerHTML = it('3_MONTHS');
			} else {
				promoTime.innerHTML = it('FCC_BROADBAND_PROMO_TIME');
			}
		} else {
			promo_container.classList.add('hidden');
			non_promo_container.classList.remove('hidden');
		}
	} catch (e) {
		console.error(`Error updating broadband card details: ${e.message}`);
	}
}

function scrollToTargetFromUrl() {
	const params = new URLSearchParams(window.location.search);
	const id = params.get('section');
	if (!id) {
		return;
	}

	const target = document.getElementById(id);
	if (!target) {
		return;
	}

	const header = document.getElementById('main_header');
	const offset = header ? header.offsetHeight : 0;
	const top = target.getBoundingClientRect().top + window.scrollY - offset;

	window.scrollTo({ top: top, behavior: 'smooth' });
}
